// GlobalProvider.js
import React, { createContext, useEffect, useState } from 'react';
import { fetchStores } from './ServerCall';
import { getUserCurrentLocation } from './utils/commanFunctions';
const GlobalContext = createContext();

const GlobalProvider = ({ children }) => {
  const storedFilter = localStorage.getItem("filter");
const appDATA = localStorage.getItem("appData");
const preservedData = localStorage.getItem("preservedData");
const initialFilter = storedFilter || (appDATA || preservedData ? "Personalized" : "all");
    const [stores, setStores] = useState([]);
    const [placeData, setPlaceData] = useState([]);
    const [eventData, setEventData] = useState([]);
    const [singleStore, setSingleStore] = useState({});
    const [hotelData, setHotelData] = useState({});
    const [personalizedB,setPersonalizedB] = useState(false)
    const [selectedPage, setSelectedPage] = useState("Places");
    const [filter, setFilter] = useState(initialFilter);
    const [filterLoading,setFilterLoading] = useState(false)
    const [userLocation,setuserLocation] = useState([])

  const setPreserveData = ()=>{
    let data = JSON.parse(localStorage.getItem("preservedData"))
    if(data){
      setStores(data.allPlaceAndEvent);
      setPlaceData(data.places)
      setEventData(data.events)
      localStorage.setItem("appData",JSON.stringify(data))
      localStorage.removeItem("preservedData")
    }
  }


    const fetchNextStore  = async (page)=>{
        console.log(page,"dddddddddddddddddd")
        const res = await fetchStores(page);
        if (res.status) {
          setStores((p)=>[...p,...res.data]);
           return res
        }
        else{
            console.log(res)
            return res
        }
      }

      const fetchNextPlace  = async (page)=>{
        console.log(page,"dddddddddddddddddd")
        const res = await fetchStores(page,"PLACE");
        if (res.status) {
     setPlaceData((p)=>[...p,...res.data]);
     setStores((p)=>[...p,...res.data])
           return res
        }
        else{
            console.log(res)
            return res
        }
      }

      const fetchNextEvent  = async (page)=>{
        console.log(page,"dddddddddddddddddd")
        const res = await fetchStores(page,"EVENT");
        if (res.status) {
     setEventData((p)=>[...p,...res.data]);
     setStores((p)=>[...p,...res.data])
           return res
        }
        else{
            console.log(res)
            return res
        }
      }

      const init = async (setLoading,page) => {
        console.log("pamge",page)
      
       switch (page) {
        case "Map":
        {
          let res = await fetchStores(1,null,setLoading);
          if (res.status) {
            setStores(res.data);
          } else {
            console.log(res);
          }
          if(setLoading)
          setLoading((p)=>false)
          return res
          break;
        }
        case "List":
          {
            let resP = await fetchStores(1,"PLACE",setLoading)
            let resE = await fetchStores(1,"EVENT",setLoading)
            if(resP.status)
            setPlaceData(resP.data)
            if(resE.status)
            setEventData(resE.data)
            if(setLoading)
            setLoading((p)=>false)
            return {
              status: resE.status || resP.status
            }
            break;
          }
        default:
          break;
       }
     
      }

      const handleFilter = async(type,setLoading,createHotelDetails,hotelData,page) => {
        console.log(page)
        if (type === "Personalized") {
          const appData = localStorage.getItem("appData");
          const preservedData = localStorage.getItem("preservedData");
      
          if (!appData) {
            if (preservedData) {
              let data = JSON.parse(preservedData)
              setStores(data.allPlaceAndEvent);
              setPlaceData(data.places)
              setEventData(data.events)
              localStorage.setItem("appData", preservedData);
              localStorage.removeItem("preservedData");
              setFilter("Personalized")
              localStorage.setItem("filter","Personalized")
            } else {
              // window.location.href = `/`;
              setPersonalizedB(true)
            }
            if (hotelData && Object.keys(hotelData).length > 0) {
              createHotelDetails(hotelData,true)
          }
          }
        } else if (type === "all") {
          const appData = localStorage.getItem("appData");
          
          if (appData) {
            
           let data = await init(setLoading,page);
          //  console.log(data,"dkkkkkkkkkkkk")
           if(data.status){
            localStorage.setItem("preservedData", appData);
            localStorage.removeItem("appData");
            setFilter("all");
            localStorage.setItem("filter","all")
            if (hotelData && Object.keys(hotelData).length > 0) {
              createHotelDetails(hotelData,true)
          }
           }
         
          }
     
        }
      }; 


    return (
        <GlobalContext.Provider value={{init,setPreserveData,handleFilter, stores, setStores, placeData, setPlaceData, eventData, setEventData,singleStore, setSingleStore,hotelData, setHotelData,personalizedB,setPersonalizedB,fetchNextStore,selectedPage, setSelectedPage,fetchNextEvent,fetchNextPlace,filter, setFilter,filterLoading,setFilterLoading,userLocation,setuserLocation }}>
            {children}
        </GlobalContext.Provider>
    );
};

// Export the provider and context
export { GlobalProvider, GlobalContext };
